import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { database } from "../services/firebase";
import { ref, onValue } from "firebase/database";
import { Navigate } from "react-router-dom";

export default function PremiumRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  const [allowed, setAllowed] = useState(null);

  useEffect(() => {
    if (!user) {
      setAllowed(false);
      return;
    }

    const subRef = ref(database, `subscriptions/${user.uid}`);

    const unsubscribe = onValue(
      subRef,
      (snapshot) => {
        if (!snapshot.exists()) {
          setAllowed(false);
          return;
        }

        const data = snapshot.val();

        if (!data || !data.expiryTimestamp) {
          setAllowed(false);
          return;
        }

        const expiry = new Date(data.expiryTimestamp);

        if (data.premium && expiry > new Date()) {
          setAllowed(true);
        } else {
          setAllowed(false);
        }
      },
      (error) => {
        console.error("Firebase error:", error);
        setAllowed(false);
      }
    );

    return () => unsubscribe();
  }, [user]);

  // ✅ Prevent white screen
  if (loading || allowed === null) {
    return (
      <div className="text-center mt-5">
        <h3>⏳ Checking access...</h3>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;
  if (!allowed) return <Navigate to="/subscription" />;

  return children;
}